module.exports = __webpack_public_path__ + "static/media/peya-delivery-icon.f9f49076.svg";